export default "__VITE_ASSET__CBWi4dif__"